<div *ngIf="error?.message">
  <div class="alert-{{ error.type }} p-3 mb-3 rounded whitespace-pre-line" [innerHTML]="error.message | replace: ';':'<br\/>'"></div>
</div>
